import { render } from "./AdditionalMenuResidentPortal.vue?vue&type=template&id=370e294c&scoped=true"
import script from "./AdditionalMenuResidentPortal.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdditionalMenuResidentPortal.vue?vue&type=script&charset=utf-8&lang=js"

import "./AdditionalMenuResidentPortal.vue?vue&type=style&index=0&id=370e294c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370e294c"]])

export default __exports__